module.exports = __webpack_public_path__ + "img/car5.82e6f810.png";